export default {
  awaiting_payment: 'Awaiting Payment',
  partially_paid: 'Partially Paid',
  paid_in_full: 'Paid in Full',
  dispatched: 'Dispatched',
  completed: 'Completed',
};
